import EventBus from './events';
import store from '../store/store';
import {axios} from '../bootstrap'

EventBus.$on('user-authenticated', function () {
    store.dispatch('setUserFromToken');
    let $query = new URLSearchParams(location.search),
        url = $query.get('redirect');
    location.assign(url ? url : '/dashboard');
});

EventBus.$on('user-logged-out', () => {
    store.commit('setAuthenticatedUser', {user: null});
    axios.delete(process.env.VUE_APP_API_URL + '/v1/logout').then(async () => {
        location.assign('/');
    });
});

EventBus.$on('user-profile-set', function (user) {

});
